import { observable, runInAction } from 'mobx'
import GlobalState from './GlobalState'

export type Article = {
  cat: string
  id: number
  title: string
  text: string
  maincat: string | 'products-services' | 'news'
  slag: string
}

type SearchStateType = {
  searchRes: null | Array<Article>
}
const SearchState: SearchStateType = observable({
  searchRes: null,
})

export default SearchState

export const searchArticles = async (params: any, lang: string) => {
  try {
    const fd = new FormData()
    fd.append('param', JSON.stringify(params))
    fd.append('status', 'poisk')
    fd.append('lang', lang)
    const request = await fetch(
      GlobalState.domain,
      {
        method: 'POST',
        body: fd,
      },
    )

    localStorage.setItem('search', params)

    const response = await request.json()
    runInAction(() => {
      SearchState.searchRes = response || null
    })
  } catch (e) {
    console.log(e)
  }
}
